// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GroupWorkPlaceModalForm_wrapper__V1F5J","loaderWrapper":"GroupWorkPlaceModalForm_loaderWrapper__1h6uS"};